module.exports = "<!-- begin::Scroll Top -->\n<div class=\"m-scroll-top m-scroll-top--skin-top\" data-toggle=\"m-scroll-top\" data-scroll-offset=\"500\" data-scroll-speed=\"300\" appunwraptag=\"\">\n\t<i class=\"la la-arrow-up\"></i>\n</div>\n<!-- end::Scroll Top -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/layouts/scroll-top/scroll-top.component.html
// module id = ../../../../../src/app/theme/layouts/scroll-top/scroll-top.component.html
// module chunks = main